export const banners = {
  hummel: ['/images/banners/hummel_3.jpg'],
  icepeak: [
    '/images/banners/icepeak_13.jpg',
    '/images/banners/icepeak_14.jpg',
    '/images/banners/icepeak_15.jpg',
    '/images/banners/icepeak_16.jpg',
  ],
  luhta: [
    '/images/banners/luhta_10.jpg',
    '/images/banners/luhta_11.jpg',
    '/images/banners/luhta_12.jpg',
  ],
  rukka: [
    '/images/banners/rukka_9.jpg',
    '/images/banners/rukka_10.jpg',
  ],
  'cobra-puma-golf': ['/images/banners/cobra-puma-golf.jpg'],

  trilite: ['/images/banners/trilite_1.jpg'],

  dachstein: ['/images/banners/dachstein.jpg'],
  'elite-sport': ['/images/banners/elite_sport.jpg'],
}

